import React from "react";
import { IGatsbyImageData, getImage, getSrc, getSrcSet } from 'gatsby-plugin-image';
import { SvgLogoImage } from "types/svg-logo-image";

type GatsbyImageTagProps = {
    image?: IGatsbyImageData;
    svgLogoImage?: SvgLogoImage;
    alt?: string;
    lazy?: boolean;
}

/**
 * Gatsby Image Tag - creates an img tag with the image data 
 */
const GatsbyImageTag: React.FC<GatsbyImageTagProps> = ({ image, svgLogoImage, alt, lazy }) => {

    // if there's an svgLogoImage, use that first
    if (svgLogoImage?.url) {
        return (
            <img src={svgLogoImage.url} alt={alt} loading={lazy ? "lazy" : undefined} width={svgLogoImage.width} height={svgLogoImage.height} />
        );
    }

    const imageData = getImage(image || null);
    const imgSrc = imageData ? getSrc(imageData) : '';
    const imgSrcSet = imageData ? getSrcSet(imageData) : '';

    return (
        <img src={imgSrc} srcSet={imgSrcSet} alt={alt} width={imageData?.width} height={imageData?.height} loading={lazy ? "lazy" : undefined} />
    );
};

export default GatsbyImageTag;